module.exports = __webpack_public_path__ + "media/images/history/knopova3-d11a0b194b1aadd80b91d11a30672980.jpg";